module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-notifications-4a792ca33e652ac8fd20dc0a88286a96.svg";